<div class="task-template-ai-tab">
  <h3 id="task-ai-heading">AI definition</h3>
  <p class="text-muted">
    Optional markdown fields for agents. Communication methods are limited to the controlled list.
    Step fields are independent of template fields.
  </p>
  <div *ngIf="error" class="alert alert-danger" role="alert">{{ error }}</div>
  <div *ngIf="readOnly" class="alert alert-secondary" role="status">
    View only. You cannot edit these fields.
  </div>

  <section *ngIf="form" aria-labelledby="task-ai-heading">
    <h4>Template</h4>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Objective</mat-label>
      <textarea
        matInput
        [formControl]="templateControl('objective')"
        rows="3"
        [readonly]="readOnly"
      ></textarea>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Critical data</mat-label>
      <textarea
        matInput
        [formControl]="templateControl('critical_data')"
        rows="3"
        [readonly]="readOnly"
      ></textarea>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Data sources</mat-label>
      <textarea
        matInput
        [formControl]="templateControl('data_sources')"
        rows="3"
        [readonly]="readOnly"
      ></textarea>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Authorized communication methods</mat-label>
      <mat-select [formControl]="templateControl('authorized_communication_methods')" multiple>
        <mat-option *ngFor="let method of communicationMethods" [value]="method">
          {{ method }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </section>

  <section *ngIf="stepsForm" [formGroup]="stepsForm" aria-labelledby="step-ai-heading">
    <h4 id="step-ai-heading">Steps</h4>
    <div *ngIf="loading" role="status">Loading step AI fields...</div>
    <p *ngIf="!loading && !stepControls.length" class="text-muted">
      No additional steps. Step AI fields can be authored after steps exist.
    </p>
    <div formArrayName="steps">
      <article
        *ngFor="let step of stepControls.controls; let i = index"
        [formGroupName]="i"
        class="mb-6 p-4 border rounded"
      >
        <h5>
          Step {{ i + 1 }}
          <span *ngIf="steps[i]?.task_template?.name"> — {{ steps[i].task_template.name }}</span>
        </h5>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Objective</mat-label>
          <textarea matInput formControlName="objective" rows="2" [readonly]="readOnly"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Critical data</mat-label>
          <textarea matInput formControlName="critical_data" rows="2" [readonly]="readOnly"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Data sources</mat-label>
          <textarea matInput formControlName="data_sources" rows="2" [readonly]="readOnly"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Authorized communication methods</mat-label>
          <mat-select formControlName="authorized_communication_methods" multiple>
            <mat-option *ngFor="let method of communicationMethods" [value]="method">
              {{ method }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </article>
    </div>
  </section>

  <button
    *ngIf="!readOnly"
    type="button"
    mat-raised-button
    color="primary"
    [disabled]="savingSteps"
    (click)="save()"
    aria-label="Save Task Template AI fields"
  >
    {{ savingSteps ? 'Saving...' : 'Save AI fields' }}
  </button>
</div>
